export function timeLongFormat(time) {
    const [hours, minutes] = time.split(':')
    if (minutes === undefined) 
        return time
    return __("{h} h {m} min", { '{h}': parseInt(hours), '{m}': parseInt(minutes) })
}

/**
 * Единицы для imperialUnitsFormat — как в PHP application\components\helpers\ImperialUnits.
 */
export const IMPERIAL_UNITS = {
    DISTANCE: 'distance', // км → мили
    SPEED: 'speed',       // км/ч → мили/ч
    LENGTH: 'length',     // м → футы, 2 знака
    ALTITUDE: 'altitude', // м → футы, целые
    VOLUME: 'volume',     // м³ → фт³
    WEIGHT: 'weight',     // кг → фунты
}

/**
 * Имперский эквивалент метрического значения: «4 660 miles», «6,17 ft».
 * Формат чисел как на десктопе: пробел — разделитель тысяч, запятая — дробной части.
 *
 * @param {number} metric значение в метрике (км, км/ч, м, м³, кг)
 * @param {string} unit одно из IMPERIAL_UNITS
 * @returns {string}
 */
export function imperialUnitsFormat(metric, unit) {
    const number = (value, decimals) => {
        const [int, frac] = value.toFixed(decimals).split('.')
        const grouped = int.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        return frac ? grouped + ',' + frac : grouped
    }

    switch (unit) {
        case IMPERIAL_UNITS.DISTANCE: return number(metric * 0.621371, 0) + ' ' + __('miles')
        case IMPERIAL_UNITS.SPEED: return number(metric * 0.621371, 0) + ' ' + __('miles/h')
        case IMPERIAL_UNITS.LENGTH: return number(metric * 3.28084, 2) + ' ft'
        case IMPERIAL_UNITS.ALTITUDE: return number(metric * 3.28084, 0) + ' ft'
        case IMPERIAL_UNITS.VOLUME: return number(metric * 35.3147, 2) + ' ft³'
        case IMPERIAL_UNITS.WEIGHT: return number(metric * 2.20462, 0) + ' lbs'
    }

    throw new Error('imperialUnitsFormat: unknown unit ' + unit)
}
